import { detect } from 'detect-browser';
import env from '../../env';
import chrome from '../../Assets/Platforms/chrome.png';

const userAgentContains = (str: string) =>
  navigator.userAgent.match(new RegExp(str, 'i'));

const isIOS = userAgentContains('iPad|iPhone|iPod');
const isAndroid = userAgentContains('android');

/**
 * Returns the major iOS version parsed from the user-agent string, or 0 if not iOS.
 *
 * `react-device-detect` does not recognise iOS 26+ and incorrectly reports it as
 * "18.7", so we parse the UA directly. Safari on iOS 26+ exposes "Version/26.x"
 * while older versions only expose "OS 17_x" / "OS 18_x".
 */
const getIOSVersion = (): number => {
  if (!isIOS) return 0;
  const ua = navigator.userAgent;
  const versionMatch = ua.match(/Version\/(\d+)/);
  if (versionMatch) return parseInt(versionMatch[1], 10);
  const osMatch = ua.match(/OS (\d+)[._]/);
  if (osMatch) return parseInt(osMatch[1], 10);
  return 0;
};
const isMac = userAgentContains('Macintosh|MacIntel|MacPPC|Mac68K');
const isPC = userAgentContains('Windows|Win32|Win64|WOW64');

const iosDownloadUrl = 'https://apps.apple.com/gb/app/kindred-app/id1468277090';
const androidDownloadUrl =
  'https://play.google.com/store/apps/details?id=com.kindredsoul.kindredapp';

const MOBILE_OS = [
  'iOS',
  'Android OS',
  'BlackBerry OS',
  'Windows Mobile',
  'Amazon OS',
];

const platform = {
  platform: 'chrome',
  logo: chrome,
  link: env.chrome_extension_store_url,
};

const isMobile = () => {
  const browser = detect();
  return !!browser?.os && MOBILE_OS.includes(browser?.os);
};

const getBrowserName = () => {
  return detect()?.name;
};

export const getPlatform = () => {
  return platform;
};

export {
  isIOS,
  isAndroid,
  isMac,
  isPC,
  iosDownloadUrl,
  androidDownloadUrl,
  isMobile,
  getBrowserName,
  getIOSVersion,
};
